import { SnackbarProvider } from "notistack";
import React, { Component } from "react";
import { MyLoadingIndicator } from "../components/my-loading-indicator/MyLoadingIndicator";
import { SnackbarUtilsConfigurator } from "../SnackbarUtils";
import { TrainThemeProvider } from "./TrainThemeProvider";

export class TrainLayout extends Component {
  static displayName = TrainLayout.name;

  render() {
    return (
      <TrainThemeProvider>
        <SnackbarProvider
          SnackbarProps={{
            "aria-live": "polite"
          }}
        >
          <SnackbarUtilsConfigurator />
          {this.props.children}
        </SnackbarProvider>
        <MyLoadingIndicator />
      </TrainThemeProvider>
    );
  }
}
